import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import axios from "axios";
import { apibaseurl } from "../../../environment";
import Swal from "sweetalert2";
import Loader from "../../../core/common/selfLoder";
import useApi from "../../../core/customhook/useApi";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
type PasswordField = "password";

const Login = () => {
  const { instance } = useMsal();
  const routes = all_routes;
  const [isLoading, setIsLoading] = useState(false);
  // const logoutUser = () => {
  //   localStorage.clear();
  //   window.location.href = "/login";
  // };
  const [authData, setAuthData] = useState({
    email: "",
    password: "",
  });
  const getInputData = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
  };
  const {
    data: loginData,
    loading,
    error,
    callApi: loginApiCall,
  } = useApi("/api/employeeLogin", {
    method: "POST",
    autoCall: false,
  });
  const navigationPath = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await loginApiCall(authData);
      console.log(response);
      if (response) {
        localStorage.setItem("login", "true");
        localStorage.setItem("token", response.token);
        localStorage.setItem("employee_name", response.data.name);
        localStorage.setItem("employee_id", response.data.employee_id);
        localStorage.setItem("employee_email", response.data.email);
        localStorage.setItem("employee_photo", response.data.photo);
        localStorage.setItem("is_manager", response.data.is_manager);
        localStorage.setItem("is_exclusions", response.data.is_eligible);
        localStorage.setItem("skip_manager", response.data.skip_manager);
        localStorage.setItem("is_hod", response.data.is_hod);
        localStorage.setItem("manager_pms", response.data.manager);
        localStorage.setItem("supportMember", response.data.supportMember);
        localStorage.setItem("isMasterLogin", response.data.isMasterLogin);
        localStorage.setItem("hrHead", response.data.hrHead);
        localStorage.setItem("is_excluded_apprisal", response.data.is_excluded_apprisal);
        localStorage.setItem("isNewEmployee", response.data.isNewEmployee);
        localStorage.setItem(
          "can_raise_recruitment",
          response.data.can_raise_recruitment,
        );
         localStorage.setItem("isNewEmployee", response?.data?.isNewEmployee)
        
        if (
          response?.data?.reset_password === "false" &&
          response.data.isMasterLogin === false
        ) {
          // User must change password first
          window.location.href = `/change-password`;
        } else {
          // User can access dashboard normally
          localStorage.setItem("login", "true");
          window.location.href = "/employee-dashboard";
        }
      }
    } catch (err: any) {
      if (err?.response) {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text:
            err.response.data.message ||
            "Invalid email or password. Please try again.",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);

      const response = await instance.loginPopup(loginRequest);

      // OPTIONAL: store MSAL token if backend needs it
      localStorage.setItem("login", "true");
      localStorage.setItem("msal_token", response.accessToken);

      window.location.href = "/employee-dashboard";
    } catch (error) {
      console.error("MSAL Login Failed", error);
    } finally {
      setIsLoading(false);
    }

    // instance.loginRedirect(loginRequest);
  };

  return (
    <>
      {/* {isLoading && <Loader />} */}
      <Loader loading={isLoading} />
      <div className="container-fuild">
        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row">
            {/* this is left section */}
            <div className="col-lg-7">
              <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
                <div className="bg-overlay-img">
                  <ImageWithBasePath
                    src="/assets/img/bg/bg-01.png"
                    className="bg-1"
                    alt="Img"
                  />
                  <ImageWithBasePath
                    src="/assets/img/bg/bg-02.png"
                    className="bg-2"
                    alt="Img"
                  />
                  <ImageWithBasePath
                    src="/assets/img/bg/bg-03.png"
                    className="bg-3"
                    alt="Img"
                  />
                </div>
                <div className="authentication-card-container">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="video-background"
                  >
                    <source
                      src="/assets/img/video/team1ConsultingBannervideo.mp4"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12">
              <div className="login-form-container d-flex justify-content-center align-items-center vh-100">
                <div className="form-wrapper w-100 px-4">
                  <form className="rounded ">
                    <div className="text-center mb-4">
                      <div
                        className="logo-wrapper mx-auto"
                        style={{ maxWidth: "130px" }}
                      >
                        <ImageWithBasePath
                          src="/assets/img/logo/team1-consultancy1.png"
                          className="img-fluid logo-img"
                          alt="Logo"
                        />
                      </div>
                      <div
                        className="logo-wrapper mx-auto mt-4"
                        style={{ maxWidth: "180px" }}
                      >
                        <ImageWithBasePath
                          src="/assets/img/logo/weconnectlogo.png"
                          className="img-fluid logo-img"
                          alt="Logo"
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      {/* <label className="form-label">Email Address</label> */}
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control border-end-0"
                          name="email"
                          onChange={getInputData}
                          placeholder="Email Address"
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      {/* <label className="form-label">Password</label> */}
                      <div className="pass-group position-relative">
                        <input
                          type={
                            passwordVisibility.password ? "text" : "password"
                          }
                          className="pass-input form-control"
                          name="password"
                          onChange={getInputData}
                          placeholder="Password"
                        />
                        <span
                          className={`ti toggle-passwords position-absolute end-0 top-50 translate-middle-y pe-3 ${passwordVisibility.password ? "ti-eye" : "ti-eye-off"}`}
                          onClick={() => togglePasswordVisibility("password")}
                          style={{ cursor: "pointer" }}
                        ></span>
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div />
                      <Link
                        to={all_routes.forgotPassword}
                        className="link-danger"
                      >
                        Forgot Password?
                      </Link>
                    </div>

                    <div className="mb-4">
                      <button
                        onClick={navigationPath}
                        type="submit"
                        className="btn btn-primary signin w-100"
                      >
                        Sign In
                      </button>
                    </div>

                    {/* Divider with OR */}
                    <div className="d-flex align-items-center my-3">
                      <hr className="flex-grow-1" />
                      <span className="px-2 text-muted small">OR</span>
                      <hr className="flex-grow-1" />
                    </div>

                    <div className="mb-4">
                      <button
                        type="button"
                        className="btn w-100 bg-light text-secondary shadow-sm border"
                        onClick={handleLogin}
                      >
                        <i className="fab fa-microsoft me-2"></i>
                        Sign in with Microsoft
                      </button>
                    </div>
                  </form>
                  <div className="text-center text-gray-9">
                    © {new Date().getFullYear()} WeConnect. All rights reserved.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;

// import React, { useState } from "react";
// import ImageWithBasePath from "../../../core/common/imageWithBasePath";
// import Loader from "../../../core/common/selfLoder";
// import { useMsal } from "@azure/msal-react";
// import { loginRequest } from "../../../authConfig";

// const Login = () => {
//   const { instance } = useMsal();
//   const [isLoading, setIsLoading] = useState(false);

//   const handleLogin = async () => {
//     try {
//       setIsLoading(true);

//       const response = await instance.loginPopup(loginRequest);
//       localStorage.setItem("login", "true");
//       localStorage.setItem("msal_token", response.accessToken);

//       window.location.href = "/employee-dashboard";
//     } catch (error) {
//       console.error("MSAL Login Failed", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <>
//       <Loader loading={isLoading} />

//       <div className="container-fuild">
//         <div className="row vh-100">
//           {/* LEFT SECTION */}
//           <div className="col-lg-7 d-none d-lg-flex align-items-center justify-content-center login-background">
//             <video autoPlay loop muted className="video-background">
//               <source
//                 src="/assets/img/video/team1ConsultingBannervideo.mp4"
//                 type="video/mp4"
//               />
//             </video>
//           </div>

//           {/* RIGHT SECTION */}
//           <div className="col-lg-5 d-flex align-items-center justify-content-center">
//             <div className="w-75 text-center">

//               <ImageWithBasePath
//                 src="/assets/img/logo/team1-consultancy1.png"
//                 className="img-fluid mb-4"
//                 alt="Logo"
//               />

//               <ImageWithBasePath
//                 src="/assets/img/logo/weconnectlogo.png"
//                 className="img-fluid mb-4"
//                 alt="Logo"
//               />

//               <button
//                 className="btn btn-primary w-100 py-2"
//                 onClick={handleLogin}
//               >
//                 <i className="fab fa-microsoft me-2"></i>
//                 Sign in with Microsoft
//               </button>

//               <div className="mt-4 text-muted">
//                 © {new Date().getFullYear()} WeConnect. All rights reserved.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;
